module.exports = __webpack_public_path__ + "static/media/Environmental Studies.b17e3d8a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OTH/Environmental Studies.pdf
// module id = 151
// module chunks = 0